import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const updateMe: UseCase<AuthRepository, 'updateMe'> = repository => {
  return async updateMe => {
    await repository.updateMe(updateMe)
  }
}
